import { gql } from '@apollo/client';

export const CLAIM_BOOKING_LOOKUP = {
  lookupBookingForClaim: gql`
    query lookupBookingForClaim($value: LookupBookingForClaimInput!) {
      lookupBookingForClaim(value: $value) {
        bookingNumber
        status
        sailors {
          id
          citizenship
          clientId
          dob
          email
          name {
            first
            last
          }
          phone {
            code
            number
          }
          sex
        }
        reservationDetails {
          packageCode
          packageType
          fromDate
          toDate
          isMNVV
        }
        noOfGuests
      }
    }
  `,
  generateClaimBookingOTP: gql`
    mutation generateClaimBookingOTP($value: GenerateClaimBookingOTPInput!) {
      generateClaimBookingOTP(value: $value) {
        status
        message
      }
    }
  `,
  claimBooking: gql`
    mutation claimBooking($value: ClaimBookingRequest!) {
      claimBooking(value: $value) {
        status
        message
        sailors {
          id
          citizenship
          clientId
          dob
          email
          name {
            first
            last
          }
          phone {
            code
            number
          }
          sex
        }
        reservationDetails {
          packageCode
          packageType
          fromDate
          toDate
          isMNVV
        }
        bookingNumber
        noOfGuests
      }
    }
  `,
  postClaimSailorProfileUpdate: gql`
    mutation postClaimSailorProfileUpdate($value: PostClaimSailorProfileUpdateInput!) {
      postClaimSailorProfileUpdate(value: $value) {
        success
        message
        clientId
      }
    }
  `,
};
